import { selectChangeMessageForPersonPicker } from '@UI/aside/asidePersonPicker/asidePersonPickerSelectors';
import type { EditAsideContactsOrCreators } from '@nodeTypeConfig/configTypes';
import { defaultAuthorsParameters } from '@store/constants/constants';

export const authorsComponent: EditAsideContactsOrCreators = {
  component: 'authors',
  property: 'creators',
  reactComponent: 'AsidePersonPicker',
  label: 'Auteurs',
  asideChangeMessageSelector: selectChangeMessageForPersonPicker,
  options: {
    queryParams: defaultAuthorsParameters,
  },
};
